// Wire vocabulary owned by config/kickavenue.php under `customer_review`.
export const AWAITING_REVIEW_STATUS = 'AWAITING_REVIEW';

export const STATUS_LABELS = {
  AWAITING_REVIEW: 'Awaiting Review',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

// BadgeThin ships no colour map — this view supplies its own.
export const STATUS_BADGE_COLORS = {
  AWAITING_REVIEW: 'info',
  APPROVED: 'success',
  REJECTED: 'danger',
};

export const SOURCE_LABELS = {
  user: 'User',
  admin: 'Admin',
};

export const ITEM_CONDITION_LABELS = {
  BRAND_NEW: 'Brand New',
  '99_PERCENT': '99 Percent',
  USED: 'Used',
};

export const NO_WRITTEN_REVIEW_TEXT = 'No written review';
export const NOT_YET_MODERATED_TEXT = 'Not yet moderated';
export const ACCOUNT_REMOVED_TEXT = 'Account removed';

export const DEFAULT_ERROR_500_MSG = 'We got something errors. Please ask our staff!';
export const DEFAULT_ERROR_404_MSG = 'Sorry, cannot find what you are looking for.';
export const MODERATION_FALLBACK_MSG = 'Could not update this review, please try again.';

export const APPROVE_DECISION = 'approve';
export const REJECT_DECISION = 'reject';

export const DECISION_CONFIRMATIONS = {
  [APPROVE_DECISION]: 'Approve this review? This cannot be undone.',
  [REJECT_DECISION]: 'Reject this review? This cannot be undone.',
};

// Shown on the acting button while its request is in flight.
export const DECISION_PROGRESS_LABELS = {
  [APPROVE_DECISION]: 'Approving...',
  [REJECT_DECISION]: 'Rejecting...',
};

// Outcome banner at the top of the review card once the decision lands. The
// tone follows the decision, not the request: a successful rejection is drawn
// in the danger tone.
export const DECISION_SUCCESS_MESSAGES = {
  [APPROVE_DECISION]: 'Review approved',
  [REJECT_DECISION]: 'Review rejected',
};

export const DECISION_OUTCOME_COLORS = {
  [APPROVE_DECISION]: 'success',
  [REJECT_DECISION]: 'danger',
};
